// Simplified-Chinese dictionary, assembled from per-area fragments. Each fragment owns the
// strings for one slice of the UI (one file per area keeps parallel translation conflict-free).
// Keys are the exact English source strings (natural keys — see ../i18n.tsx).
import { common } from './messages/common.zh'
import { auth } from './messages/auth.zh'
import { videos } from './messages/videos.zh'
import { notes } from './messages/notes.zh'
import { library } from './messages/library.zh'
import { taxonomy } from './messages/taxonomy.zh'
import { home } from './messages/home.zh'
import { admin } from './messages/admin.zh'

export const zh: Record<string, string> = {
  ...common,
  ...auth,
  ...videos,
  ...notes,
  ...library,
  ...taxonomy,
  ...home,
  ...admin,
}
